import React, { useEffect } from 'react'
import logo from './logo.svg';
import './App.css';
import { useLocation, BrowserRouter, Routes, Route, Link, useNavigate, Navigate, Outlet } from 'react-router-dom'
import Home from '@pages/home'
import Contract1 from '@pages/contract1'
import Contract2 from '@pages/contract2'
import Login from '@pages/login'
import Logout from '@pages/logout'
import AdminIndex from '@pages/admin/admin-index';
import AdminOrderView from '@pages/admin/admin-order.view';
import AdminDrawer from '@components/AdminDrawer'
import { isAdmin, isRepManager, isManager, isDirectManager } from '@util/helper'
import { Provider, useSelector, useDispatch } from 'react-redux'
import { createTheme, ThemeProvider, CssBaseline, Container, Typography } from '@mui/material'
import { GlobalStyle as gs } from '@src/GlobalStyle'
import MyInfo from '@pages/my/my-info';
import BranchInfo from '@pages/branch/branch-info';
import BranchList from '@pages/branch/branch-list'
import PayResult from '@pages/pay-result';
import Error from '@pages/error';
import Test from '@pages/test'
import ReivewList from '@pages/review/review-list'
import ReviewList from '@pages/review/review-list';
import ContractCustom from '@pages/contract-custom'

const theme = createTheme({
  typography: {
    fontSize: 14, // Adjust the base font size
  },
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          cursor: 'pointer',
        },
      },
    },
    MuiTableCell: {
      defaultProps: {
        size: 'small', // Set the default size to "small"
      },
    },
    MuiButton: {
      defaultProps: {
        size: 'middle',
        variant: 'outlined',
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'outlined',
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiInputLabel: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: 'none', // Set elevation to 0
          border: '1px solid silver', // Set border to 1px solid silver
        },
      },
    },
    // MuiGrid: {
    //   styleOverrides: {
    //     root: {
    //       display:'flex',
    //       alignItems:'center',
    //     }
    //   }
    // },
  },
  palette: {
    primary: {
      main: gs.colors.main,
      bar: gs.colors.bar,
    },
  },
  // spacing: 8,
  // You can add more customizations to the theme here
})




const AdminRoute = ({ children }) => {
  const account = useSelector((state) => state.accountReducer)
  return isAdmin(account) ? <Outlet /> : <Navigate to='/logout' />
}

function App() {

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      process.env.NODE_ENV === "development"
        ? "https://sandbox.cookiepayments.com/js/cookiepayments-1.1.3.js"
        : "https://www.cookiepayments.com/js/cookiepayments-1.1.3.js";

    script.async = true;
    document.body.appendChild(script);

    console.log('process.env.NODE_ENV=>', process.env.NODE_ENV)
    return () => {
      document.body.removeChild(script);
    };
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/contract1' element={<Contract1 />} />
          <Route path='/contract1/:productCode' element={<Contract1 />} />
          <Route path='/contract2' element={<Contract2 />} />
          <Route path='/contract-custom' element={<ContractCustom />} />
          <Route path='/pay/result' element={<PayResult />} />
          <Route path='/login' element={<Login />} />
          <Route path='/logout' element={<Logout />} />
          <Route path='/error' element={<Error />} />
          <Route path='/logout/:secured' element={<Logout />} />
          <Route path='/admin' element={<AdminRoute />}>
            <Route path='' element={<AdminDrawer />}>
              <Route index element={<AdminIndex/>} />
              <Route path='order/view' element={<AdminOrderView/>} />
              <Route path='branch' element={<BranchList />} />
              <Route path='branch/rooms' element={<BranchInfo />} />
              <Route path='review' element={<ReviewList />} />
              <Route path='my' element={<MyInfo />} />
              <Route path='test' element={<Test />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>

    </ThemeProvider>
  );
}

export default App;
